import { 
  Box, 
  Button, 
  TextField, 
  Typography, 
  Paper,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { keyframes } from "@mui/material";
import theme from "../../configs/theme";

const shake = keyframes`
  0% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-5px); }
  100% { transform: translateX(0); }
`;

export default function LoginUI({
  name,
  password,
  error,
  showPassword,
  onNameChange,
  onPasswordChange,
  onSubmit,
  handleShowPassword,
}) {

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor={theme.colors.terciary}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          width: 320,
          borderRadius: 2,
          boxShadow: "5px 10px 15px rgba(0,0,0,0.8)",
        }}
      >
        <Typography variant="h5" gutterBottom align="center">
          Iniciar Sesión
        </Typography>
        <form onSubmit={onSubmit}>
          <Box sx={{ animation: error ? `${shake} 0.4s` : "none" }}>
            <TextField
              fullWidth
              label="Nombre"
              value={name}
              onChange={onNameChange}
              margin="normal"
              error={error}
            />
            <TextField
              fullWidth
              label="Contraseña"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={onPasswordChange}
              margin="normal"
              error={error}
              helperText={
                error ? "Nombre de usuario o contraseña incorrectos" : ""
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleShowPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
          >
            Entrar
          </Button>
        </form>
      </Paper>
    </Box>
  );
}
